import classNames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Heading from '@jpp/atoms/Heading';
import BlogCard from '@jpp/molecules/BlogCard';
import { EBlogCardVariant } from '@jpp/molecules/BlogCard/BlogCard';
import { IReduxState } from 'common/redux/createStore';
import { IPostStoreState } from 'common/redux/post/reducer';
import { getAllPosts } from 'common/redux/posts/selectors';
import { getPosts } from 'common/redux/rootActions';

import './RelatedPosts.scss';

interface IRelatedPostsProps {
  className?: string;
  posts?: IPostStoreState[];
  limit?: number;
}

const ROOT_CLASSNAME = 'RelatedPosts';

const RelatedPosts: React.FunctionComponent<IRelatedPostsProps> = ({
  className,
  limit = 4,
  ...props
}) => {
  const dispatch = useDispatch();
  const postsFromState = useSelector((state: IReduxState) =>
    getAllPosts(state)
  );
  const posts = props.posts || postsFromState;

  React.useEffect(() => {
    if (!posts) {
      dispatch(getPosts());
    }
  }, []);

  if (!posts) {
    return null;
  }

  return (
    <div className={classNames(ROOT_CLASSNAME, className)}>
      <Heading
        priority={2}
        className={`${ROOT_CLASSNAME}__heading`}
        children="More Brewery Updates"
      />

      {posts.slice(0, limit).map((post, index) => {
        return (
          <BlogCard
            key={`${post.slug} ${index}`}
            post={post}
            className={`${ROOT_CLASSNAME}__post`}
            variant={EBlogCardVariant.Related}
          />
        );
      })}
    </div>
  );
};

export default RelatedPosts;
